import { DEV } from 'js/utils/constants/dev'
import { lang } from 'store/lang.store'
import { setupCache, buildWebStorage } from 'axios-cache-interceptor'
import axios from 'axios'
import { useDevTricks } from 'composables/useDevTricks'

const csrf = window.context.csrf
const { config: devConfig } = useDevTricks()

const API_HEADER = {
  post: {
    'X-CSRFTOKEN': csrf,
  },
  'X-CSRFToken': csrf,
  'Accept-Language': lang.value,
}

const instance = axios.create({
  baseURL: '/',
  withCredentials: true,
  headers: API_HEADER,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFTOKEN',
  cache: false,
})

const api = instance
// const api = setupCache(instance, {
//   storage: buildWebStorage(localStorage, 'axios-cache:'),
// })

api.interceptors.request.use(
  function requestMethod(config) {
    if (config.method !== 'get') {
      if (!devConfig.value.cache.clearOnMutation && DEV) return
      api?.storage?.clear()
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

const URLS = {
  users: '/api/users/',
  solicitacoesArquivos: '/api/solicitacoes-arquivos/',
  grupoArquivos: '/api/grupos-arquivos/',
  categoriaArquivos: '/api/categorias-arquivos/',
  arquivos: '/api/arquivos/',
  materiais: 'api/materiais/',
  parametros: 'api/parametros/',
  tiposMateriais: 'api/tipos-materiais/',
  comentariosSolicitacoes: '/api/comentarios-solicitacoes-arquivos/',
  logs: '/api/logs-solicitacoes-arquivos/',
  modal_atencao: '/api/modal-atencao/',
  template_unificado_columns:
    'api/template-unificado-campos/columns/',
  template_unificado_campos: 'api/template-unificado-campos/table/',
  template_unificado_multiple_update:
    'api/template-unificado/multiple-update/',
  grupo_template_unificado: 'api/grupo-template-unificado/',
  template_unificado_anos_disponiveis:
    'api/template-unificado-campos/anos_disponiveis/',
  avisos: '/api/avisos/',
  justificativas: 'api/justificativas/',
  validacoes: '/api/configuracao-campo/',

  reports_summary: '/copa/api/reports/summary/',
  reports_overview: '/copa/api/reports/overview/',
  reports_evolution: '/copa/api/reports/evolution/',
  reports_enablers: '/copa/api/reports/enablers/',
  reports_quick_wins: '/copa/api/reports/quick-wins/',
  reports_highlights: '/copa/api/reports/highlights/',

  zones: '/copa/api/filters/zones/',
  bottlers: '/copa/api/filters/bottlers/',
  copa_auth: '/copa/api/auth/',
  copa_tiers: '/copa/api/filters/tiers/',
}

export { api, URLS, API_HEADER }

// export default function ({ csrf }) {
// 	axios.defaults.xsrfCookieName = 'csrftoken'
// 	axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"
// 	axios.defaults.headers.post['X-CSRFTOKEN'] = csrf;
//   axios.defaults.baseURL =

// }
